import { ComponentPropsWithoutRef, forwardRef } from "react";
import clsx from "clsx";

import styles from "./divider.module.scss";

type DividerProps = {
  /** Optional extra class(es) */
  className?: string;
  /** Set to true to remove the margins */
  noMargin?: boolean;
  /** Enable for thin variant */
  thin?: boolean;
} & ComponentPropsWithoutRef<"hr">;

const Divider = forwardRef<HTMLHRElement, DividerProps>(
  ({ className, noMargin, thin, ...rest }, ref) => {
    const classes = [
      styles.hr,
      className,
      { [styles.noMargin]: noMargin, [styles.thin]: thin },
    ];
    return (
      <hr {...rest} ref={ref} aria-hidden="true" className={clsx(classes)} />
    );
  }
);

Divider.displayName = "Divider";

export default Divider;
